/*
* Thème: STACK
*/

import '@fancyapps/fancybox'

window.Lightbox_PluginInit = function () {
	$('.fancybox-link').fancybox({
		loop: true,
		buttons: ['close'],
		transitionEffect: 'slide',
		backFocus: false,
		caption: function (instance, current) {
			const $trigger = $(current.opts.$orig);
			var caption = ''
			if ($trigger.next('figcaption').length) {
				var caption = '<div class="builder-image-caption">' + $trigger.next('figcaption').html() + '</div>';
			}
			return caption
		},
	})

	$('.--fancybox-grid > .grid__item > div[class^="card-"]').each(function(index) {
		if ($(this).find('div[class*="__image"] a').length == 0) {
			if ($(this).find('div[class*="__image"]').length) {
				if ($(this).find('div[class*="__image"]').data('full-size') != '') {
					$(this).attr('href', $(this).find('div[class*="__image"]').data('full-size'))
					$(this).addClass('fancybox-grid-item')
				}
			}
		}
	})

	// Group fancybox galleries by grid
	$('.--fancybox-grid').each(function(index) {
		$(this).find('a:not([class*="__cta"]), .fancybox-grid-item').attr('data-fancybox', 'grid__' + index)
	})

	$('.--fancybox-grid a:not([class*="__cta"]), .fancybox-grid-item').fancybox({
		loop: true,
		buttons: ['close'],
		transitionEffect: 'slide',
		lang: document.body.lang || document.documentElement.lang,
		backFocus: false,
		caption: function (instance, current) {
			const $trigger = $(current.opts.$orig);
			var card_content = ''
			if ($trigger.closest('.grid__item').find('div[class*="__content"]').length) {
				card_content = $trigger.closest('.grid__item').find('div[class*="__content"]')[0].outerHTML;
			} else {
				if ($trigger.closest('.grid__item').find('[class*="__title"]').length) {
					card_content += $trigger.closest('.grid__item').find('[class*="__title"]')[0].outerHTML
				}
				if ($trigger.closest('.grid__item').find('[class*="__description"]').length) {
					card_content += $trigger.closest('.grid__item').find('[class*="__description"]')[0].outerHTML
				}
				if ($trigger.closest('.grid__item').find('[class*="__cta"]').length) {
					card_content += $trigger.closest('.grid__item').find('[class*="__cta"]')[0].outerHTML
				}
			}
			if ($trigger.closest('.grid__item').find('[class*="__cta"]').length == 0) {
				if ($trigger.get(0).tagName == 'A') {
					card_content += '<a href="' + $trigger.attr('href') + '" class="fancybox-grid-link __cta">' + dayalabs_l10n.LEARN_MORE + '</a>'
				}
			}
			var caption = '<div class="grid__item"><div class="card-">' + card_content + '</div></div>'
			return caption
		},
		beforeLoad: function (instance, current) {
			const $trigger = $(current.opts.$orig);
			const imageSrc = $trigger.closest('.grid__item').find('[class*="__image"]').data('full-size')
			current.src = imageSrc;
			if ($trigger.closest('.grid__item').find('video').length) {
				current.type = 'video';
			} else {
				current.type = 'image';
			}
		},
	})
}

/* End: STACK */
